import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { brandConfiguration } from "@/brands/config";
import { useI18n } from "@/shared/hooks";
import { Box } from "@gemini/core";
import { ChevronDownIcon, InfoCircleIcon } from "@gemini/icons";
import { Checkbox } from "@gemini/ui";
import { Controller } from "react-hook-form";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
import { TooltipInfos } from "@/components/utilsComponents";
import { useState, useRef, useEffect, useCallback } from "react";
import { useBrowserAPI } from "@/hooks/useBrowserAPI";
export const SaveSearchOptIn = ({ control, testId, isSaveSearchOptInEnabled, }) => {
    const { t } = useI18n();
    const { brandName } = brandConfiguration;
    const isPreviewMode = useIsPreviewMode();
    if (!isSaveSearchOptInEnabled)
        return;
    return (_jsxs(Box, { display: "flex", width: "100%", children: [_jsx(Box, { display: "flex", alignItems: "baseline", marginTop: "-spacing.4", children: _jsx(Controller, { name: "newsletterOptout", control: control, defaultValue: false, render: ({ field: { value = false, onChange, name, ref } }) => (_jsxs(_Fragment, { children: [_jsx(Checkbox, { isOptional: true, "aria-label": "Newsletter Opt\u2011in", hasNecessityIndicator: false, testId: `${testId}.SavedSearchOptIn`, isSelected: value !== null && value !== void 0 ? value : false, ref: ref, onChange: onChange, name: name, defaultSelected: false, isDisabled: isPreviewMode, children: "" }), _jsxs(Box, { position: "relative", top: "-spacing.4", children: [value
                                        ? t("contact.form.saved_search_opt_in.text", {
                                            replace: { value: brandName },
                                        })
                                        : t("contact.form.saved_search_opt_in.text_not_checked", {
                                            replace: { value: brandName },
                                        }), "\u00A0", !value && (_jsx(Box, { display: "inline-block", children: _jsx(Controller, { name: "newsletterOptInPreference", control: control, defaultValue: "email-sms", render: ({ field: { value = "email-sms", onChange }, }) => (_jsx(CustomDropdown, { value: value, onChange: onChange, isDisabled: isPreviewMode })) }) }))] })] })) }) }), _jsx(Box, { marginTop: "spacing.6", children: _jsx(TooltipInfos, { content: t("contact.form.saved_search_opt_in.tooltip"), icon: _jsx(InfoCircleIcon, { size: "sizing.24", color: "color.background.constant.black" }) }) })] }));
};
const CustomDropdown = ({ value, onChange, isDisabled, }) => {
    const { t } = useI18n();
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    const buttonRef = useRef(null);
    const { bDocument } = useBrowserAPI();
    const options = [
        { id: "email-sms", label: "Email / SMS" },
        { id: "email", label: "Email" },
        { id: "sms", label: "SMS" },
    ];
    const currentLabel = t(value
        ? `contact.form.marketing_opt_in_out_${value}_dropdown_option`
        : "contact.form.marketing_opt_in_out_email-sms_dropdown_option");
    const handleButtonClick = (e) => {
        e.stopPropagation();
        if (!isDisabled) {
            setIsOpen((prev) => !prev);
        }
    };
    const handleClickOutside = useCallback((event) => {
        // eslint-disable-next-line no-restricted-globals
        const target = event.target;
        if (dropdownRef.current &&
            !dropdownRef.current.contains(target) &&
            buttonRef.current &&
            !buttonRef.current.contains(target)) {
            setIsOpen(false);
        }
    }, [setIsOpen]);
    useEffect(() => {
        if (isOpen) {
            bDocument.addEventListener("mousedown", handleClickOutside, true);
        }
        return () => {
            bDocument.removeEventListener("mousedown", handleClickOutside, true);
        };
    }, [isOpen, handleClickOutside, bDocument]);
    const handleOptionClick = (optionId) => {
        onChange(optionId);
        setIsOpen(false);
    };
    return (_jsxs(Box, { position: "relative", display: "inline-flex", alignItems: "center", padding: "0px", children: [_jsxs(Box, { as: "span", ref: buttonRef, cursor: "pointer", onClick: handleButtonClick, display: "inline-flex", tabIndex: 0, onKeyDown: (e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        e.stopPropagation();
                        setIsOpen((prev) => !prev);
                    }
                }, "aria-haspopup": "true", "aria-expanded": isOpen, typography: "typography.body.16.boldUnderlined", children: [currentLabel, _jsx(ChevronDownIcon, { "aria-label": "Dropdown icon", color: "inherit", size: "sizing.24" })] }), isOpen && (_jsx(Box, { ref: dropdownRef, position: "absolute", top: "100%", left: 0, zIndex: "zIndex.1", backgroundColor: "color.background.constant.white", borderWidth: "borderWidth.1", borderColor: "color.border.default.default", borderRadius: "radius.8", boxShadow: "shadow.16", minWidth: "160px", marginTop: "8px", overflow: "hidden", paddingTop: "8px", paddingBottom: "8px", children: options.map((option) => (_jsx(Box, { onClick: () => handleOptionClick(option.id), width: "100%", paddingHorizontal: "16px", paddingVertical: "12px", textAlign: "left", cursor: "pointer", display: "block", backgroundColor: value === option.id
                        ? "color.surface.interactive.selected.default"
                        : "color.background.constant.white", color: value === option.id
                        ? "color.content.constant.white"
                        : "color.content.default.default", children: option.label }, option.id))) }))] }));
};
